export const ENTITY_TYPES = {
  CATEGORY: 'category',
  PROVIDER: 'provider',
  THEME: 'theme',
};
